var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      !_vm.isInAmap
        ? _c("call-amap-bar", {
            ref: "callAmapBar",
            attrs: { schema: _vm.callSchema, pageType: _vm.page_type },
            on: { openAmapLog: _vm.openAmapLog, goAmap: _vm.callAmap },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "contentWrap",
          staticClass: "content-wrap",
          class: { "content-in": _vm.isInAmap, "content-out": !_vm.isInAmap },
        },
        [
          _vm.pageType === 0
            ? _c("title-comp", {
                ref: "titllCome",
                attrs: {
                  "title-obj": _vm.titleObj,
                  "title-type": _vm.titleType,
                  logParams: _vm.logParams,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isShowWeather
            ? _c("Weather", {
                staticClass: "weather-box",
                attrs: { weather: _vm.weather },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("Notification"),
          _vm._v(" "),
          _c("div", {
            ref: "pushContent",
            staticClass: "push-content",
            class: {
              "text-mode": _vm.pageType === 0,
              "preview-mode": _vm.pageType === 1,
            },
            domProps: { innerHTML: _vm._s(_vm.richText) },
          }),
          _vm._v(" "),
          _vm.extFunc === 2
            ? _c(
                "div",
                {
                  staticStyle: {
                    padding: "0 0.16rem",
                    "flex-shrink": "1",
                    "margin-top": "0.4rem",
                  },
                },
                [
                  _vm.realTimeData && _vm.congestDataList.length
                    ? _c("CongestionSituation", {
                        attrs: {
                          showMap: _vm.mapLoaded,
                          "real-time-data": _vm.realTimeData,
                          "congest-data-list": _vm.congestDataList,
                          "congest-data-inited": _vm.congestDataInited,
                          "area-type": _vm.areaType,
                          "update-time": _vm.updateTime,
                          "city-adcode": _vm.cityAdcode,
                          "unit-id": _vm.unitId,
                          logParams: _vm.logParams,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.areaType === 0 || _vm.areaType === 2) && _vm.predictData
                    ? _c("TrafficForecast", {
                        attrs: {
                          "predict-data": _vm.predictData,
                          "city-name": _vm.cityName,
                          "unit-id": _vm.unitId,
                          logParams: _vm.logParams,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isInAmap && _vm.canShowAd
            ? _c("Banner", { attrs: { "page-type": _vm.pageType } })
            : _vm._e(),
          _vm._v(" "),
          _vm.isInWeixin ? _c("Qrcode") : _vm._e(),
          _vm._v(" "),
          _vm.showImgPreview
            ? _c("img-preview", {
                attrs: {
                  imgUrls: _vm.imgUrlArr,
                  currentIndex: _vm.currentIndex,
                },
                on: { closeImagePopup: _vm.handleImgPreviewClose },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("feedback-entry", {
            attrs: { adiu: _vm.adiu, "is-in-amap": _vm.isInAmap },
          }),
          _vm._v(" "),
          _vm.newsList && _vm.newsList.length
            ? _c("hot-news-list", {
                attrs: {
                  newsList: _vm.newsList,
                  categoryList: _vm.categoryList,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pageType === 0
            ? _c("div", { staticClass: "push-footer" })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.currentShowAudio
                ? _c("hover-dot", {
                    attrs: { "link-audio": _vm.currentShowAudio },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showGuideOpenTag
            ? _c("GuideOpenTag", {
                attrs: {
                  id: _vm.id,
                  schema: _vm.callSchema,
                  pageType: _vm.page_type,
                },
                on: {
                  close: _vm.modalCloseGuideOpenTag,
                  openAmapLog: _vm.openAmapLog,
                  goAmap: _vm.callAmap,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isInAmap
        ? _c("call-amap-btn", {
            attrs: { schema: _vm.callSchema, pageType: _vm.page_type },
            on: { openAmapLog: _vm.openAmapLog, goAmap: _vm.callAmap },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "info-scence-window": true,
            "info-scence-window-active": _vm.infoScenceWindowRes,
            "animation-apear": _vm.infoScenceWindowRes,
          },
          on: { click: _vm.openInfoScenceWindow },
        },
        [
          _c("div", { staticClass: "title-container" }, [
            _c("div", { staticClass: "title-common-style main-title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.infoScenceWindowRes
                      ? _vm.infoScenceWindowRes.material[0].text.title
                      : ""
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "title-common-style sub-title" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.infoScenceWindowRes
                      ? _vm.infoScenceWindowRes.material[0].text.short_title
                      : ""
                  ) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("button", { staticClass: "btn" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.infoScenceWindowRes
                    ? _vm.infoScenceWindowRes.material[0].button.button_text
                    : ""
                ) +
                "\n    "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }